import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { Paginador } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import Paginator, { PageState } from "primevue/paginator"
  import { useI18n } from "vue-i18n"

  interface Props {
    opcoesItensPorPagina?: Array<number>
    leitor: Paginador
    aoPaginar: (event: PageState) => void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'APaginadorDeTabela',
  props: {
    opcoesItensPorPagina: { default: () => [5, 10, 20, 30] },
    leitor: null,
    aoPaginar: null
  },
  setup(__props: any) {

  const { t } = useI18n()

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Paginator), {
    onPage: __props.aoPaginar,
    "current-page-report-template": `{first}-{last} ${_unref(t)('de')} {totalRecords}`,
    "data-testid": "APaginadorDeTabela",
    first: __props.leitor.definirPagina(),
    rows: __props.leitor.itensPorPagina,
    "rows-per-page-options": __props.opcoesItensPorPagina,
    template: "FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown",
    "total-records": __props.leitor.totalDeResultados
  }, null, 8, ["onPage", "current-page-report-template", "first", "rows", "rows-per-page-options", "total-records"]))
}
}

})